<template>
  <div class="main-body">
    <!--头部-->
    <jm-crumbs/>
    <el-form
      :model="searchData"
      label-width="90px">
      <el-row>
        <el-col :span="8">
          <el-form-item
            label-width="200"
            label="客户编码：">
            <el-input
              v-model.trim="searchData.id"
              class="jm-input175"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label-width="200"
            label="当前客户分级：">
            <jm-dict-select
              class="jm-input135"
              clearable
              type="dataset"
              v-model="searchData.customerClassification"
              dict-type="student"
              name="customLvType"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label-width="200"
            label="签约时间：">
            <el-date-picker
              :editable="false"
              v-model="searchData.signingDate"
              value-format="yyyy-MM-dd"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input280"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label-width="200"
            label="姓名：">
            <el-input
              v-model.trim="searchData.custom_name"
              class="jm-input175"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label-width="200"
            label="昵称：">
            <el-input
              v-model.trim="searchData.custom_nickname_tell"
              class="jm-input175"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label-width="200"
            label="重复进入时间：">
            <el-date-picker
              :editable="false"
              v-model="searchData.creationDate"
              type="daterange"
              unlink-panels
              placeholder="选择日期"
              class="jm-input280"/>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            label-width="200"
            label="重复进入渠道：">
            <jm-channel
              v-model="searchData.channel"
              clearable
              filterable/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label-width="200"
            label="重复进入创建人：">
            <el-select
              v-model="searchData.create_person"
              filterable
              class="jm-input135"
              clearable
              placeholder="请选择">
              <el-option-group
                v-for="(group, k) in ds.create_person"
                :key="k"
                :label="k">
                <el-option
                  v-for="item in group"
                  :key="item.userid"
                  :label="item.username"
                  :value="item.userid"/>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label-width="200"
            label="重复进入前客户分级：">
            <jm-dict-select
              class="jm-input135"
              clearable
              type="dataset"
              v-model="searchData.originCustomerClassification"
              dict-type="student"
              name="customLvType"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="basic-padding jm-tac">
            <el-button
              class="jm-input175"
              type="primary"
              @click="() => this.refresh = true">搜索</el-button>
            <el-button
              class="jm-input175"
              type="default"
              @click="resetFields">重置</el-button>
            <el-button
              class="jm-input175"
              v-if="$hasPermission([62])"
              type="primary"
              :loading="exporting"
              @click="exportSnapshot">导出数据</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <jm-tableList
      style="margin-top: 30px;"
      url="/index/student/snapshotPagetable"
      :search-data="searchData"
      :refresh.sync="refresh">
      <el-table-column
        slot="lastColumn"
        label="操作"
        width="80"
        align="center"
        v-if="$hasPermission([62])">
        <template slot-scope="scope">
          <router-link
            target="_blank"
            :to="{name:'editStudent', params: { id: scope.row.crmid }}">
            <el-button
              type="primary"
              size="small">查 看</el-button>
          </router-link>
        </template>
      </el-table-column>
    </jm-tableList>
  </div>
</template>

<script>
import crumbs from '@/components/tool/crumbs.vue';
import tableList from '@/components/data/tableList.vue';
import { jmChannel, jmDictSelect } from '@/components/tool';
import { formatSelectGroupData, getGlobalSearchData } from '@/utils/utils.js';

export default {
  data() {
    return {
      searchData: {
        id: '',
        custom_name: '',
        custom_nickname_tell: '',
        creationDate: [],
        channel: {
          custom_from: '',
          custom_from_sub: '',
          custom_from_thrid: '',
          custom_from_fourth: '',
          custom_from_fifth: '',
        },
        create_person: '',
        customerClassification: '',
        originCustomerClassification: '',
      },
      refresh: false,
      ds: {},
      exporting: false,
    };
  },
  methods: {
    /**
       * Description: 重置搜索条件
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = '';
      });
      this.searchData.creationDate = [];
      this.searchData.channel = {
        custom_from: '',
        custom_from_sub: '',
        custom_from_thrid: '',
        custom_from_fourth: '',
        custom_from_fifth: '',
      };
      this.$store.commit('updateRefresh', true);
    },
    exportSnapshot() {
      this.exporting = true;
      this.$http._post({
        url: '/index/student/exportSnapshot',
        data: this.searchData,
      }).then(({ data }) => {
        this.exporting = false;
        this.$http._download({
          filename: data,
          download: '重复进入资源记录.xlsx'
        });
      }).catch((data) => {
        if (typeof data.data !== 'undefined' && data.data.result === -1) {
          this.$message.error(data.data.data);
        } else {
          this.$message.error('服务异常');
        }
        this.exporting = false;
      });
    },
  },
  mounted() {
    getGlobalSearchData().then((data) => {
      // 创建人
      this.ds.create_person = formatSelectGroupData(data.create_person);
    });
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    jmChannel,
    jmDictSelect,
  },
};
</script>

<style>
</style>
